<template>
    <div class="auth-page">
        <el-dialog 
            :visible.sync="popVisible"
            title="编辑企业基础信息"
            width="760px"
            class="dialog-header-border"
            :close-on-click-modal="false"
            @close="$emit('update:visible', false)"
        >   
            <div class="form-wrap">
                <el-form :model="authForm" :rules="rules" ref="authForm" label-position="top"
                :hide-required-asterisk="true"
                >
                    <el-form-item label="公司名称" prop="companyName">
                        <el-input size="small" style="width: 450px" v-model.trim="authForm.companyName"
                        type="text"
                        placeholder="请输入公司名称"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="营业执照号" prop="companyLicenseNumber">
                        <el-input size="small" style="width: 450px" v-model="authForm.companyLicenseNumber"
                        type="text"
                        placeholder="请输入营业执照号(五证合一)"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="营业执照" prop="validLisenseImgUrl">
                        <el-upload
                            name='files'
                            :data="{
                                imageType:'20201',
                                imageUserId: userId,
                            }"
                            :action="uploadApi"
                            :show-file-list="false"
                            :on-success="onUploadSuccess"
                            :on-error="onUploadError"
                            class="auth-upload"
                        >   
                            <template>
                                <div class="upload-default" v-if="!licenseImgUrl">
                                    <i class="el-icon-plus ic"></i>
                                    <span>上传图片</span>
                                </div>
                                <div class="upload-img-box" v-else @click.stop>
                                    <img
                                        class="upload-img"
                                        :src="licenseImgUrl"
                                    >
                                    <span class="upload-img-actions">
                                        <span
                                            class="upload-img-actions-item"
                                            @click.stop="handleLicenseImgPreview"
                                        >
                                            <i class="el-icon-zoom-in"></i>
                                        </span>
                                        <span
                                            class="upload-img-actions-item"
                                            @click.stop="handleLicenseImgRemove"
                                        >
                                            <i class="el-icon-delete"></i>
                                        </span>
                                    </span>
                                </div>
                            </template>
                        </el-upload>
                    </el-form-item>

                    <el-form-item label="法定代表人" prop="companyKeyPerson2"  v-if="userType==2">
                        <el-input size="small" style="width: 450px" v-model.trim="authForm.companyKeyPerson2"
                        type="text"
                        placeholder="请输入法定代表人姓名"
                        ></el-input>
                    </el-form-item>

                    <el-form-item label="公司电话" prop="companyPhone">
                        <el-input size="small" style="width: 450px" v-model.trim="authForm.companyPhone"
                        type="text"
                        placeholder="请输入公司电话"
                        ></el-input>
                    </el-form-item>

                    <el-form-item :label="userType==2 ? '工厂地址' : '公司地址'" prop="validBrandAddress">
                        <div style="width: 450px; ">
                            <area-picker type="edit" :data.sync="brandCompanyArea" @change="getCompanyAreaData"/>
                        </div>
                        <el-input size="small" style="width: 450px; margin-top: 8px" v-model="brandDetailAddress"
                        type="text" @input="inputBrandDetailAddress"
                        placeholder="请输入详细地址"
                        ></el-input>
                    </el-form-item>

                    <el-form-item label="业务负责人" prop="companyKeyPerson" v-if="userType==1 || userType==9">
                        <el-input size="small" style="width: 450px" v-model.trim="authForm.companyKeyPerson"
                        type="text"
                        placeholder="请输入业务负责人姓名"
                        ></el-input>
                    </el-form-item>

                    <el-form-item label="业务负责人电话" prop="companyKeyPersonPhone" v-if="userType==1 || userType==9">
                        <el-input size="small" style="width: 450px" v-model.trim="authForm.companyKeyPersonPhone"
                        type="text"
                        placeholder="请输入业务负责人电话"
                        ></el-input>
                    </el-form-item>

                    <el-form-item label="品牌" prop="validBrandTags" v-if="userType==1">
                        <el-tag
                            :key="tag"
                            v-for="tag in brandTags"
                            closable
                            :disable-transitions="false"
                            @close="handleTagClose(tag)">
                            {{tag}}
                        </el-tag>
                        <el-input
                            class="input-new-tag"
                            v-if="brandInputVisible"
                            v-model="brandInputValue"
                            ref="saveTagInput"
                            size="small"
                            @keyup.enter.native="handleTagInputConfirm"
                            @blur="handleTagInputConfirm"
                            placeholder="请输入品牌名称"
                        >
                        </el-input>
                        <el-button v-else class="button-new-tag" size="small" @click="showTagInput">+ 品牌</el-button>
                    </el-form-item>

                    <el-form-item label="工厂实拍照片（至少3张）" prop="validImgList" v-if="userType==2">
                        <el-upload
                            name='files'
                            :data="{
                                imageType:'20301',
                                imageUserId: userId,
                            }"
                            list-type="picture-card"
                            :action="uploadApi"
                            :on-preview="handlePictureCardPreview"
                            :on-remove="handlePictureCardRemove"
                            :file-list="facFileList"
                            class="img-list-upload"
                           
                            :on-success="onImgListUploadSuccess"
                            :on-error="onUploadError"
                        >   
                            <div class="upload-default" slot="default">
                                <i class="el-icon-plus ic"></i>
                                <span>上传图片</span>
                            </div>
                            <!-- <div slot="file" slot-scope="{file}">
                                <img
                                    class="el-upload-list__item-thumbnail"
                                    :src="file.url"
                                >
                                <span class="el-upload-list__item-actions">
                                    <span
                                        class="el-upload-list__item-preview"
                                        @click="handlePictureCardPreview(file)"
                                    >
                                        <i class="el-icon-zoom-in"></i>
                                    </span>
                                    <span
                                        class="el-upload-list__item-delete"
                                        @click="handlePictureCardRemove(file)"
                                    >
                                        <i class="el-icon-delete"></i>
                                    </span>
                                </span>
                            </div> -->
                            <!-- <div class="upload-default" slot="default">
                                <i class="el-icon-plus ic"></i>
                                <span>上传图片</span>
                            </div> -->
                        </el-upload>
                    </el-form-item>
                    <el-button class="cg-el-btn-widen" @click="cancelSubmit">取 消</el-button>
                    <el-button class="cg-el-btn-widen" type="primary" @click="submitAuthForm">提 交</el-button>
                </el-form>
            </div>  
        </el-dialog>
        <el-dialog :visible.sync="dialogImgVisible">
            <img width="100%" :src="dialogImgUrl" alt="">
        </el-dialog>
    </div>
</template>

<script>
// import api from '@/api/index.js'
// import request from '@/utils/request'

import { ajaxPost, api } from '@/common/request.js'
import { ajaxApp, api_app } from '@/common/request_app.js'

import areaPicker from './areaPicker.vue'
export default {
    components: {
        areaPicker
    },
    computed: {
       
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        userId: {
            type: [String, Number]
        },
        userType: {
            type: [String, Number]
        }
    },
    data() {
        var validLisenseImgUrl = (rule, value, callback) => {
            if (this.licenseImgUrl == '') {
                callback(new Error('请上传营业执照'))
            } else {
                callback()
            }
        };
        var validBrandAddress = (rule, value, callback) => {
            if (!(this.brandCompanyArea.regionCity && this.brandCompanyArea.regionCity.region_id)) {
                callback(new Error('请选择区域'))
            } else if (!this.brandDetailAddress) {
                callback(new Error('请填写详细地址'))
            } else {
                callback()
            }
        };
        var validBrandTags = (rule, value, callback) => {
            if (this.brandTags.length == 0) {
                callback(new Error('请添加品牌'))
            } else {
                callback()
            }
        };
        var validImgList = (rule, value, callback) => {
            if (this.facFileList.length < 3) {
                callback(new Error('请上传至少3张工厂实拍图片'))
            } else {
                callback()
            }
        };
        return {
            popVisible: false,
            uploadApi: api_app.baseUrl + '/file/uploadfilebatch',

            authForm: {
                companyName: '',
                companyLicenseNumber: '',
                companyPhone: '',
                companyKeyPerson: '', // 业务负责人
                companyKeyPerson2: '', // 法定代表人
                companyKeyPersonPhone: ''
            },
            rules: {
                companyName: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' },
                ],
                companyLicenseNumber: [
                    { required: true, message: '请输入营业执照号', trigger: 'blur' },
                ],
                companyPhone: [
                    { required: true, message: '请输入公司电话', trigger: 'blur' },
                ],
                companyKeyPerson: [
                    { required: true, message: '请输入业务负责人姓名', trigger: 'blur' },
                ],
                companyKeyPerson2: [
                    { required: true, message: '请输入法定代表人姓名', trigger: 'blur' },
                ],
                companyKeyPersonPhone: [
                    { required: true, message: '请输入业务负责人电话', trigger: 'blur' },
                ],
                validLisenseImgUrl: [
                    { validator: validLisenseImgUrl }
                ],
                validBrandAddress: [
                    { validator: validBrandAddress }
                ],
                validBrandTags: [
                    { validator: validBrandTags}
                ],
                validImgList: [
                    { validator: validImgList}
                ]
            },

            // 营业执照
            licenseImgUrl: '',
            licenseImgData: '',

            dialogImgVisible: false,
            dialogImgUrl: '',


            // 工厂实拍照片
            facFileList: [],

            // 品牌商地址 （生产商，直播相关也暂时使用这个字段）
            brandCompanyArea: {
                regionProvince: {
                    region_name:  '',
                    region_id: ''
                },
                regionCity: {
                    region_name:  '',
                    region_id: ''
                },
                regionDistrict: {
                    region_name:  '',
                    region_id: ''
                }
            },
            brandDetailAddress: '',

            // 品牌
            brandTags: [],
            brandInputVisible: false,
            brandInputValue: ''
        }
    },
    watch: {
        visible: function(val) {
            this.popVisible = val
            if (val) {
                this.getAuthInfo()
                if (this.userType == 1) {
                    this.getBrandInfo()
                }
            }
        }
    },
    created() {
    
    },
    methods: {

        getAuthInfo() {
            ajaxApp('/yijiajiaUserAuth/findUserAuthInfo', {
                userId: this.userId
            }).then(res => {
                console.log('/yijiajiaUserAuth/findUserAuthInfo', res)
                if (res.errorCode == 200) {
                    this.authForm.companyName = res.data.companyName
                    this.authForm.companyLicenseNumber = res.data.companyLicenseNumber
                    this.authForm.companyPhone = res.data.companyPhone
                    if (this.userType == 2) {
                        this.authForm.companyKeyPerson2 = res.data.companyKeyPerson
                    } else {
                        this.authForm.companyKeyPerson = res.data.companyKeyPerson
                        this.authForm.companyKeyPersonPhone = res.data.companyKeyPersonPhone
                    }
                    this.brandDetailAddress = res.data.factoryAddressStr
                    this.brandCompanyArea = {
                        regionProvince: {
                            region_name:  res.data.companyProvinceStr || '',
                            region_id: res.data.companyProvince || ''
                        },
                        regionCity: {
                            region_name:  res.data.companyCityStr || '',
                            region_id: res.data.companyCity || ''
                        },
                        regionDistrict: {
                            region_name:  res.data.companyDistrictStr || '',
                            region_id: res.data.companyDistrict || ''
                        }

                    }

                    if (res.data.businessLicenseImg) {
                        let idObj={
                            imgId: res.data.businessLicenseImgId
                        }
                        this.licenseImgUrl = api.imgPrev + res.data.businessLicenseImg
                        this.licenseImgData = '{"imgId":"' + res.data.businessLicenseImgId + '"}'
                    }
                    if (res.data.picturesTakenInFactories) {
                        this.facFileList = res.data.picturesTakenInFactories.map(v => {
                            return {
                                name: v.image_file,
                                url: api.imgPrev + v.image_file,
                                response: {
                                    data: '{"imgId":"' + v.imgId + '"}'
                                }
                            }
                        })
                    }
                    
                }
            })
        },

        getBrandInfo() {
            ajaxApp('/yijiajiaUserAuth/showUserAuthBrand', {
                userId: this.userId
            }).then(res => {
                // console.log('api.showUserAuthBrand', res)
                if (res.errorCode === 200) {
                    if (res.data.companyBrand) {
                        this.brandTags = res.data.companyBrand.split(',')
                    }
                }
            })
        },

        // 上传工厂照片
        onImgListUploadSuccess(res,file, fileList) {
            // console.log(res,file, fileList)
            this.facFileList = fileList
            // console.log(this.facFileList)
            this.$refs['authForm'].validateField('validImgList')
        },
        handlePictureCardRemove(file, fileList) {
            // console.log(file, fileList);
            this.facFileList.splice(this.facFileList.indexOf(file), 1)
            this.$refs['authForm'].validateField('validImgList')
        },
        handlePictureCardPreview(file) {
            this.dialogImgUrl = file.url;
            this.dialogImgVisible = true;
        },


        // 添加品牌
        handleTagClose(tag) {
            this.brandTags.splice(this.brandTags.indexOf(tag), 1)
            this.$refs['authForm'].validateField('validBrandTags')
        },
        showTagInput() {
            this.brandInputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        handleTagInputConfirm() {
            let brandInputValue = this.brandInputValue;
            if (brandInputValue) {
                this.brandTags.push(brandInputValue);
                this.$refs['authForm'].validateField('validBrandTags')
            }
            this.brandInputVisible = false;
            this.brandInputValue = '';
        },

        // 地址
        getCompanyAreaData(data) {
            // console.log('getCompanyAreaData', data)
            // console.log('this.brandCompanyArea', this.brandCompanyArea)
            this.$refs['authForm'].validateField('validBrandAddress')
        },
        inputBrandDetailAddress() {
            this.$refs['authForm'].validateField('validBrandAddress')
        },

        // 上传营业执照
        onUploadSuccess(res, file, fileList) {
            // console.log('onUploadSuccess', res, file, fileList)
            if (res.errorCode == 200) {
                this.licenseImgData = res.data
                this.licenseImgUrl = URL.createObjectURL(file.raw)
                this.$refs['authForm'].validateField('validLisenseImgUrl')
            } else {
                this.$message.error('上传失败')
            }
        },
        onUploadError(err, file, fileList) {
            // console.log('onUploadError', err, file, fileList)
            this.$message.error('上传失败')
        },
        handleLicenseImgRemove() {
            this.licenseImgUrl = ''
            this.licenseImgData = ''
            this.$refs['authForm'].validateField('validLisenseImgUrl')
        },
        handleLicenseImgPreview() {
            this.dialogImgUrl = this.licenseImgUrl;
            this.dialogImgVisible = true;
        },
        switchImageData(data) {
            let arr = data.split(',')
            arr = arr.map(v => JSON.parse(v))
            return arr
        },
        // 去除字符之间的空格
        removeSpace(str) {
            return str.replace(/\s/g, '')
        },
        cancelSubmit() {
            this.$emit('update:visible', false)
        },
        submitAuthForm() {
            this.$refs['authForm'].validate(valid => {
                if (valid) {
                    // console.log('pass')
                    let params = {}
                    if (this.userType == 1) {
                        let imageJsonStr = JSON.stringify(this.switchImageData(this.licenseImgData))
                        params = {

                            userId: this.userId,
                            companyName: this.authForm.companyName,
                            companyLicenseNumber: this.removeSpace(this.authForm.companyLicenseNumber),
                            companyPhone: this.authForm.companyPhone,
                            companyKeyPerson: this.authForm.companyKeyPerson,
                            companyKeyPersonPhone: this.authForm.companyKeyPersonPhone,
                            
                            companyProvince: this.brandCompanyArea.regionProvince.region_id || '',
                            companyCity:  this.brandCompanyArea.regionCity.region_id || '',
                            companyDistrict:  this.brandCompanyArea.regionDistrict.region_id || '',
                            factoryAddress: this.brandDetailAddress,

                            companyBrand: this.brandTags.join(","),
                            imageJson: imageJsonStr
                        }
                    }

                    if (this.userType == 2) {
                        let facFileListData = this.facFileList.map(v => v.response.data)
                        let imageArr = [this.licenseImgData, ...facFileListData]
                        let imageJsonStr = JSON.stringify(imageArr.map(v => this.switchImageData(v)).flat())
                        
                        params = {
                            userId: this.userId,
                            companyName: this.authForm.companyName,
                            companyLicenseNumber: this.removeSpace(this.authForm.companyLicenseNumber),
                            companyPhone: this.authForm.companyPhone,
                            companyKeyPerson: this.authForm.companyKeyPerson2,
                            companyKeyPersonPhone: '',
                            
                            companyProvince: this.brandCompanyArea.regionProvince.region_id || '',
                            companyCity:  this.brandCompanyArea.regionCity.region_id || '',
                            companyDistrict:  this.brandCompanyArea.regionDistrict.region_id || '',
                            factoryAddress: this.brandDetailAddress,
                            imageJson: imageJsonStr,
                            companyBrand: ''
                        }
                    }

                    if (this.userType == 9) {
                        let imageJsonStr = JSON.stringify(this.switchImageData(this.licenseImgData))
                        params = {
                            userId: this.userId,
                            companyName: this.authForm.companyName,
                            companyLicenseNumber: this.removeSpace(this.authForm.companyLicenseNumber),
                            companyPhone: this.authForm.companyPhone,
                            companyKeyPerson: this.authForm.companyKeyPerson,
                            companyKeyPersonPhone: this.authForm.companyKeyPersonPhone,
                            
                            companyProvince: this.brandCompanyArea.regionProvince.region_id || '',
                            companyCity:  this.brandCompanyArea.regionCity.region_id || '',
                            companyDistrict:  this.brandCompanyArea.regionDistrict.region_id || '',
                            factoryAddress: this.brandDetailAddress,

                            imageJson: imageJsonStr,
                            companyBrand: ''
                        }
                    }
                    ajaxPost('/admin/yijiajiaUserAuth/updateUserAuthInfo', params).then(res => {
                        console.log('/admin/yijiajiaUserAuth/updateUserAuthInfo', res)
                        if (res.errorCode == 200) {
                            this.$emit('update:visible', false)
                            this.$message.success('编辑成功')
                            this.$emit('on-success', res)
                        } else {
                            this.$message.error(res.errorMsg || '网络错误')
                        }
                    }).catch(err => {
                        console.log(err)
                    })
                }
            })
        }
    }
}
</script>

<style lang="scss">
.auth-page {
    .form-wrap {
        padding: 0 24px 32px;
    }
    .auth-upload {
        width: 104px;
        height: 104px;
        border-radius: 2px;
        
        .upload-default {
            width: 104px;
            height: 104px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            border: 1px dashed #c0ccda;
            .ic {
                font-size: 20px;
                color: rgba(0, 0, 0, 0.65);
            }
            span {
                margin-top: 10px;
                font-size: 14px;
                color: rgba(0, 0, 0, 0.65);
                line-height: 22px;
            }
            &:hover {
                border-color: #409EFF;
                color: #409EFF;
                .ic, span {color: #409EFF;}
            }
        }
        .upload-img-box {
            width: 104px;
            height: 104px;
            position: relative;
            border: 1px solid #c0ccda;
            .upload-img {
                width: 104px;
                height: 104px;
                object-fit: cover;
            }
            &:hover .upload-img-actions{
                display: flex;
            }
            .upload-img-actions {
                position: absolute;
                width: 104px;
                height: 104px;
                left: 0;
                top: 0;
                justify-content: center;
                align-items: center;
                display: none;
                background: rgba(0, 0, 0, 0.5);
            }
            .upload-img-actions-item {
                padding: 0 4px;
                margin: 0 10px;
                color: #fff;
            }
        
        }
        
    }

    .el-tag {
        margin-right: 10px;
    }
    .button-new-tag {
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }
    .input-new-tag {
        width: 150px;
        vertical-align: bottom;
    }

    /* 表单 label独占一行时*/
    .el-form--label-top .el-form-item__label {
        padding: 0;
    }
    /* 弹框 加线*/
    .dialog-header-border .el-dialog__header {
        border-bottom: 1px solid #e5e5e5;
    }

    /* upload 照片墙样式重置 */
    .img-list-upload {
        .el-upload--picture-card {
            width: 104px;
            height: 104px;
            border-radius: 2px;
            line-height: 1;
            .upload-default {
                width: 104px;
                height: 104px;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                .ic {
                    font-size: 20px;
                    color: rgba(0, 0, 0, 0.65);
                }
                span {
                    margin-top: 10px;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.65);
                    line-height: 22px;
                }
            }
            &:hover, &:focus {
                .upload-default .ic, .upload-default span {
                    color: #409EFF
                }
            }
        }
        .el-upload-list--picture-card .el-upload-list__item {
            border-radius: 2px;
            width: 104px;
            height: 104px;
        }
        
    }
}


</style>


// WEBPACK FOOTER //
// src/pages/customer/components/editBasicInfo.vue